const source = 'kec';
const Version = '2016-03-04';
const Service = 'kec';
const KecPath = '/kecapi/';
const noLoginKecApi = '/noLoginKecApi/';


export const QueryKecData = {
    method: 'post',
    path: KecPath,
    params: {
        Action: 'QueryKvmList',
        Service,
        Version,
        source,
    }
};

export const QueryNetworkResource = {
    method: 'post',
    path: KecPath,
    params: {
        Action: 'QueryNetworkResource',
        Service: 'vpc',
        Version,
        source
    }
}

export const QueryPriceSystem = {
    method: 'post',
    path: KecPath,
    params: {
        Action: 'QueryPriceSystem',
        Service,
        Version,
        source,
        productGroupId: 100,
        vmType: 'as',
    }
};

// 试用订单余额查询
export const kecTryOrder = {
    path: KecPath,
    params: {
        Action: 'QueryFreeTrialWallet',
        Version,
        Service,
        source
    }
};
export const kecGetSnap = {
    method: 'post',
    path: KecPath,
    params: {
        Action: 'DescribeLocalVolumeSnapshots',
        Service,
        Version,
        source
    }
};
export const kecSnapLimitNum = {
    path: KecPath,
    params: {
        Action: 'CreateSnapshotInstNum',
        Version,
        Service,
        source
    }
};
export const kecRegions = {
    method: 'get',
    path: KecPath,
    params: {
        Action: 'RegionInfos',
        Service,
        Version,
        source
    }
};

export const kecImageList = {
    path: KecPath,
    params: {
        Action: 'ImageConfig',
        Service,
        Version,
        source
    },
    method: 'get'
};

export const kecDiyImage = {
    path: KecPath,
    params: {
        Action: 'DescribeImages',
        Service,
        Version,
        source
    },
    method: 'get'
};
export const kecQueryDisCount = {
    path: KecPath,
    params: {
        Action: 'QueryUserSpecialDiscounts',
        Version,
        Service,
        source
    },
    method: 'get'
};

export const kecCalcKvmPrice = {
    path: KecPath,
    params: {
        Action: 'CalculateKVMPrice',
        Version,
        Service,
        source
    },
    method: 'post'
};

export const calculateResPrice = {
    path: KecPath,
    params: {
        Action: 'CalculateResPrice',
        Version,
        Service,
        source
    },
    method: 'post'
};


export const getEbsSnap = {
    path: KecPath,
    params: {
        Action: 'DescribeSnapshots',
        Version,
        Service,
        source
    },
    method: 'post'
}
//获取镜像市场镜像
export const describeMarketTAbList = {
    path: KecPath,
    params: {
        Action: 'DescribeMarketImageCategories',
        Version,
        Service,
        source
    },
    method: 'get'
}
//获取竞价实例历史价格
export const DescribeSpotPriceHistory = {
    path: KecPath,
    params: {
        Action: 'DescribeSpotPriceHistory',
        Version,
        Service,
        source
    },
    method: 'get'
}
//获取镜像市场镜像
export const describeMarketImage = {
    path: KecPath,
    params: {
        Action: 'DescribeMarketImages',
        Version,
        Service,
        source
    },
    method: 'post'
}

export const QueryMaxBootNum = {
    path: KecPath,
    params: {
        Action: 'QueryMaxBootNum',
        Version,
        Service,
        source
    }
}

// 获取主机详情--实例启动模板使用
export const DescribeModels = {
    method: 'post',
    path: KecPath,
    params: {
        Action: 'DescribeModels',
        Service,
        Version,
        source
    }
};

// 获取主机详情
export const GetInstanceByIds = {
    method: 'post',
    path: KecPath,
    params: {
        Action: 'GetInstanceByIds',
        Service,
        Version,
        source
    }
};

//查询通用折扣信息
export const queryCommonDiscount = {
    method: 'get',
    path: KecPath,
    params: {
        Action: 'QueryCommonDiscount',
        Service,
        Version,
        source,
    }
};

export const batchCalculateKVMPrice = {
    method: 'post',
    path: KecPath,
    params: {
        Action: 'BatchCalculateKVMPrice',
        Service,
        Version,
        source,
    }
};
export const GetQuota = {
    method: 'post',
    path: KecPath,
    params: {
        Action: 'DescribeQuotaInfoByQuotaName',
        Service,
        Version,
        source
    }
};
//检查快照状态
export const DescribeSnapshotServiceStatus = {
    method: 'post',
    path: KecPath,
    params: {
        Action: 'DescribeSnapshotServiceStatus',
        Service: 'kec',
        Version,
        source
    }
};
//检查用户是否开通快照服务
export const checkSnapShotPermission = {
    method: 'post',
    path: KecPath,
    params: {
        Action: 'CheckSnapShotPermission',
        Service: 'kec',
        Version,
        source
    }
};

//开通快照服务（开通订单）
export const openSnapShotService = {
    method: 'post',
    path: KecPath,
    params: {
        Action: 'OpenSnapShotService',
        Service: 'kec',
        Version,
        source
    }
};
export const DescribeInstanceGroupCount = {
    method: 'post',
    path: KecPath,
    params: {
        Action: 'DescribeInstanceGroupCount',
        Service: 'kec',
        Version,
        source
    }
};
export const DescribeEbsPerfQuotas = {
    method: 'post',
    path: KecPath,
    params: {
        Action: 'DescribeEbsPerfQuotas',
        Service: 'kec',
        Version,
        source
    }
};

//--以下为未登录service--
export const noLoginQueryKecData = {
    method: 'post',
    path: noLoginKecApi,
    params: {
        Action: 'QueryKvmList',
        Service,
        Version,
        source,
    }
};
export const noLoginkecImageList = {
    path: noLoginKecApi,
    params: {
        Action: 'ImageConfig',
        Service,
        Version,
        source
    },
    method: 'get'
};
export const noLoginKecQueryDisCount = {
    path: noLoginKecApi,
    params: {
        Action: 'QueryUserSpecialDiscounts',
        Version,
        Service,
        source
    },
    method: 'get'
};
//查询通用折扣信息
export const noLoginQueryCommonDiscount = {
    method: 'get',
    path: noLoginKecApi,
    params: {
        Action: 'QueryCommonDiscount',
        Service,
        Version,
        source,
    }
};
//--以上为未登录service--
